import jsonata from 'jsonata';
import { isNumber, range } from 'lodash';

export const formatMoney = (v, numDecimal = 0) => {
  try {
    if (!isNumber(v)) return '';
    if (v < 1 && v > 0) {
      return Number(Number(v).toFixed(numDecimal));
    }
    let format = '#0,###';
    if (numDecimal > 0) {
      format =
        format +
        '.' +
        range(0, numDecimal)
          .map((i) => '0')
          .join('');
    }
    const expression = jsonata(`$formatNumber(v, "${format}")`);
    const result = expression.evaluate({ v });
    return result;
  } catch (err) {
    return '';
  }
};

export const roundNumber = (v, numDecimal = 0) => {
  try {
    if (!isNumber(v)) return '';
    const expression = jsonata(`$round(v, ${numDecimal})`);
    const result = expression.evaluate({ v });
    return result;
  } catch (err) {
    return '';
  }
};

export function formatNumber(
  amount: any,
  decimalCount = 0,
  decimal = '.',
  thousands = ','
) {
  return formatMoney(amount, decimalCount);
}

export const formatNumberF = (
  amount,
  decimalCount = 0,
  decimal = '.',
  thousands = ','
) => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';
    const a = (amount = Math.abs(Number(amount) || 0).toFixed(0));
    const i = parseInt(a).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - Number(i))
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  } catch (e) {
    return amount;
  }
};
